import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/images/brand/logo.png";
import "../styles/navbar.css";
import { lockBodyScroll, unlockBodyScroll } from "../utils/scrollLock";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (isOpen) {
      lockBodyScroll();
    } else {
      unlockBodyScroll();
    }
    return () => {
      unlockBodyScroll();
    };
  }, [isOpen]);

  // Cerrar menú al cambiar de ruta
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  const isActive = (path) => {
    if (path === "/") return location.pathname === "/";
    return (
      location.pathname === path || location.pathname.startsWith(path + "/")
    );
  };

  const handleSameRouteClick = (path) => {
    closeMenu();
    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const navLinks = [
    { path: "/", label: "Inicio" },
    { path: "/productos", label: "Productos" },
    { path: "/videos", label: "Aprendé" },
    { path: "/nosotros", label: "Nosotros" },
    { path: "/contacto", label: "Contacto" },
  ];

  return (
    <>
      <nav className={`navbar ${isOpen ? "menu-open" : ""}`}>
        <div className="navbar-top-line" />

        <div className="navbar-container">
          <Link
            to="/"
            className="navbar-logo"
            aria-label="Ir a inicio"
            onClick={() => handleSameRouteClick("/")}
          >
            <img src={logo} alt="STIHL Logo" />
          </Link>

          <ul className="nav-menu-desktop">
            {navLinks.map(({ path, label }) => (
              <li key={path} className="nav-item">
                <Link
                  to={path}
                  className={`nav-links ${isActive(path) ? "active" : ""}`}
                  onClick={() => handleSameRouteClick(path)}
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>

          <button
            className={`burger-btn ${isOpen ? "is-open" : ""}`}
            onClick={toggleMenu}
            aria-label={isOpen ? "Cerrar menú" : "Abrir menú"}
            aria-expanded={isOpen}
          >
            <FontAwesomeIcon icon={isOpen ? faXmark : faBars} />
          </button>
        </div>
      </nav>

      <div
        className={`mobile-overlay ${isOpen ? "visible" : ""}`}
        onClick={closeMenu}
        aria-hidden="true"
      />

      <div
        className={`mobile-drawer ${isOpen ? "is-open" : ""}`}
        aria-hidden={!isOpen}
      >
        <div className="drawer-inner">
          <ul className="drawer-nav">
            {navLinks.map(({ path, label }, index) => (
              <li
                key={path}
                className="drawer-item"
                style={{ "--item-index": index }}
              >
                <Link
                  to={path}
                  className={`drawer-link ${isActive(path) ? "active" : ""}`}
                  onClick={() => handleSameRouteClick(path)}
                >
                  <span className="drawer-link-text">{label}</span>
                  <span className="drawer-link-arrow">→</span>
                </Link>
              </li>
            ))}
          </ul>

          <div className="drawer-footer">
            <div className="drawer-brand-line" />
            <p className="drawer-tagline">Tu concesionario STIHL oficial</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
